import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { AddButton, SearchInput, Empty, inputCls } from "@/components/Bits";
import { OSCard } from "@/components/OSHistory";
import { Chip, ChipRow } from "@/pages/EquipamentosPage";
import { OS_STATUS } from "@/config/os";
import { useAuth } from "@/context/AuthContext";
import { useFetch, thisMonth } from "@/lib/useFetch";
import { NaoConcluidasResumo } from "@/components/NaoConcluidasResumo";

export default function OrdensPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [mes, setMes] = useState("");
  const { data } = useFetch("/ordens", { q: q || undefined, status: status || undefined, mes: mes || undefined });
  const nc = status === "nao_concluida" && user.role === "admin";
  const sub = { admin: "Todas as ordens de serviço.", tecnico: "Ordens que você executou ou que estão designadas para você.", cliente: "Acompanhe o status dos seus pedidos de atendimento." }[user.role];

  return (
    <div data-testid="ordens-page">
      <PageHeader eyebrow="Campo" title="Ordens de Serviço" subtitle={sub} />
      <div className="flex gap-3 mb-4">
        <SearchInput value={q} onChange={setQ} placeholder="Buscar nº da OS ou serviço" testId="os-search-input" />
        {user.role === "admin" && <AddButton onClick={() => navigate("/ordens-servico/nova")} data-testid="os-add-button">Nova OS</AddButton>}
        {user.role === "cliente" && <AddButton onClick={() => navigate("/ordens-servico/solicitar")} data-testid="os-solicitar-button">Pedir atendimento</AddButton>}
      </div>
      <ChipRow>
        <Chip active={!status} onClick={() => setStatus("")} data-testid="os-filter-all">Todas</Chip>
        {OS_STATUS.map((s) => <Chip key={s.value} active={status === s.value} onClick={() => { setStatus(s.value); if (s.value === "nao_concluida" && user.role === "admin" && !mes) setMes(thisMonth()); }} data-testid={`os-filter-${s.value}`}>{s.label}</Chip>)}
      </ChipRow>
      {user.role === "admin" && (
        <div className="flex flex-wrap items-center gap-2 mb-4">
          <label htmlFor="os-mes" className="text-sm font-semibold">Mês</label>
          <input id="os-mes" type="month" value={mes} onChange={(e) => setMes(e.target.value)} className={`${inputCls} h-12 w-48`} data-testid="os-filter-mes" />
          {mes && <button onClick={() => setMes("")} className="h-12 px-4 rounded-xl border-2 border-[#E2DDD3] text-sm font-semibold" data-testid="os-filter-mes-clear">Todos os meses</button>}
        </div>
      )}
      {nc && mes && <NaoConcluidasResumo mes={mes} />}
      {data?.length === 0 && <Empty testId="os-list-empty">Nenhuma OS encontrada.</Empty>}
      <div className="grid lg:grid-cols-2 gap-3" data-testid="os-list">{(data || []).map((o) => <OSCard key={o.os_id} o={o} />)}</div>
    </div>
  );
}
